'use strict';

import React, { useCallback, useRef, useState } from 'react'

import _ from 'lodash'

import PageWrapper from '@Layout/PageWrapper'
import Layout      from '@Layout/BackOffice'

import getFormStatus from '@/Form/Functions/getFormStatus'
import getFormData   from '@/Form/Functions/getFormData'
import FileInputV2   from '@/Form/toolkit/FileInputV2'

import Loader from '@Pure/Loader'

import ajaxRequest from '@function/ajax/ajaxRequest'
import bemit       from '@function/bemit'

const NO_STATUS = { };

export default PageWrapper(function RGPDConsentPage (props)
{
	const [upload_id, setUploadId] = useState(1);
	const [form_data, setFormData] = useState({ form_data: { } });
	const [status, setStatus] = useState({ });
	const [loading, setLoading] = useState(false);

	const file_ref = useRef();

	const handleFileChange = useCallback(function (e, data)
	{
		const name = data.name;

		setFormData(function (form_data)
		{
		// Binaires
			const __files = (form_data['__files-' + name] || [])
			.filter(function (file)
			{
				return file.form_name !== data.name;
			});

			if (data && data.value instanceof Array && data.value[0])
			{
				__files.push(data.value[0]);
			}

		// Informations
			const files_infos = (form_data[name] || [])
			.filter(function (file)
			{
				return file.form_name !== data.name;
			});

			if (data && data.value instanceof Array && data.value[0])
			{
				let infos = _.cloneDeep(data.value[0]);

				delete infos.file;
				delete infos.pdf;
				delete infos.image;

				files_infos.push(infos);
			}

			const new_form_data =
			{
				...form_data,

				['__files-' + name]: __files,
				[name]: files_infos,

				'__attachments': files_infos || []
			};

			return new_form_data;
		});
	},
	[]);

	const loader = loading === true ?
	(
		<Loader className="c-loader" bemit={ ['white', 'bg-primary'] } />
	)
	: undefined;

	return (
		<Layout history={ props.history } page_title="Retirer le consentement">

			<div className="page-content">

				<div className="o-content">

					{
						getFormStatus(
						{
							statement: 'Cet import permet de retirer le consentemement à la newsletter des utilisateurs ayant une addresse email correspondant à l\'une de celles du fichier importé.'
						})
					}

					<a href="/documents/exemples-imports/import_rgpd.csv"
						target="_blank" rel="noreferrer">
						Télécharger le fichier d'exemple.
					</a>

					<div className="u-full-width u-margin-top-30" />

					<div className="u-full-width" ref={ file_ref }>

						<FileInputV2 data={ form_data }
							onChange={ handleFileChange }
							status={ status.fields || NO_STATUS }
							name="newsletter_import"
							button_txt="Choisir le fichier à importer"
							multiple={ false }
							accept=".csv, .txt"
							key={ String(upload_id) }>
						</FileInputV2>

					</div>

					{ getFormStatus(status) }

					<div className="u-full-width u-margin-top-20">

						<button type="button" onClick={ validate }
							className={ bemit('c-btn') }>
							Valider et importer
							{ loader }
						</button>

					</div>

				</div>

			</div> { /* /page-content */ }

		</Layout>
	);

	async function validate (e)
	{
		e.preventDefault();

		setLoading(true);

		const data = getFormData({ state: form_data });

		try
		{
			var response = await ajaxRequest('/import/rgpd/newsletter',
			{
				data: data,
				axios_params: { timeout: 5 * 60 * 1000 },
				files: true
			});
		}
		catch (update)
		{
			setLoading(false);
			setUploadId(id => id+1);

			return setStatus(update);
		}

		setUploadId(id => id+1);
		setStatus(response);
		setFormData({ '__files-newsletter_import': [], newsletter_import: [] });
		setLoading(false);

		if (file_ref.current)
		{
			const input = file_ref.current.querySelector('input[type="file"]');

			if (input) input.value = '';
		}
	}
});